// import React, { useState } from 'react';
// import './AdminVouchers.css';
// import { FiChevronDown,FiZap } from "react-icons/fi";


// const subjects = ["Mathematics", "Science", "History"];
// const exams = ["Midterm", "Final", "Quiz"];
// const topics = {
//   Mathematics: ["Algebra", "Trigonometry"],
//   Science: ["Newtons Laws", "Thermodynamics"],
//   History: ["World War II", "Renaissance"]
// };

// const VoucherFormModal = ({ onClose, onSubmit }) => {
//   const [formData, setFormData] = useState({
//     subject: '',
//     topic: '',
//     exam: '',
//     validDays: '',
//     quantity:'',
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleGenerate = () => {
//     if (formData.subject && formData.topic && formData.exam && formData.validDays && formData.quantity) {
//       onSubmit(formData); // Send form data to parent
//       setFormData({
//         subject: '',
//         topic: '',
//         exam: '',
//         validDays: '',
//         quantity: ''
//       });
//     } else {
//       alert("Please fill all fields before generating the voucher.");
//     }
//   };


//   return (
//     <div className="modal-overlay">
//       <div className="modal-content">
//         <h2>Create Voucher</h2>
//         <form>

//           {/* Dropdown for subjects */}
//           <div className="custom-select-wrapper">
//             <select name="subject" value={formData.subject} onChange={handleChange} required>
//               <option value="">Select Subject</option>
//               {subjects.map((sub, idx) => (
//                 <option key={idx} value={sub}>{sub}</option>
//               ))}
//             </select>
//             <FiChevronDown className="dropdown-icon" />
//           </div>

//           {/* dropdown for topics */}
//           <div className="custom-select-wrapper">
//             <select name="topic" value={formData.topic} onChange={handleChange} required>
//               <option value="">Select Topic</option>
//               {topics[formData.subject]?.map((topic, idx) => (
//                 <option key={idx} value={topic}>{topic}</option>
//               ))}
//             </select>
//             <FiChevronDown className="dropdown-icon" />
//           </div>

//           {/* dropdown for exam */}
//           <div className="custom-select-wrapper">
//             <select name="exam" value={formData.exam} onChange={handleChange} required>
//               <option value="">Select Exam</option>
//               {exams.map((ex, idx) => (
//                 <option key={idx} value={ex}>{ex}</option>
//               ))}
//             </select>
//             <FiChevronDown className="dropdown-icon" />
//           </div>

//           <input
//             name="validDays"
//             type="number"
//             placeholder="Valid Days"
//             value={formData.validDays}
//             onChange={handleChange}
//             required
//           />


//           {/* Quantity */}
//           <input
//             name="quantity"
//             type="number"
//             placeholder="Quantity"
//             value={formData.quantity}
//             onChange={handleChange}
//             required
//           />

//           <button type="button" onClick={handleGenerate} className="generate-btn">
//             <FiZap className='zap-icon'/>
//             Generate Voucher
//           </button>


//           <div className="modal-buttons">
//             <button type="button" onClick={onClose} className="cancel-btn">Cancel</button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default VoucherFormModal;
















import React, { useState, useEffect } from 'react';
import {
  Modal,
  Backdrop,
  Fade,
  Box,
  Typography,
  Button,
  MenuItem,
  TextField,
  Snackbar,
  Alert,
  IconButton,
} from '@mui/material';
import { FiZap } from "react-icons/fi";
import CloseIcon from "@mui/icons-material/Close";
import api from '../../api';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 450,
  bgcolor: 'background.paper',
  borderRadius: 3,
  boxShadow: 24,
  p: { xs: 3, sm: 4 },
  outline: 'none',
  maxHeight: '90vh',
  overflowY: 'auto',
};

const VoucherFormModal = ({ onClose }) => {
  const [formData, setFormData] = useState({
    exam: '',
    subject: '',
    topic: '',
    validDays: '',
    quantity: '',
    expiryDate: ''
  });

  const [exams, setExams] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [topics, setTopics] = useState([]);

  const [loading, setLoading] = useState(false);
  const [successToast, setSuccessToast] = useState(false);
  const [errorToast, setErrorToast] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  // Fetch exams
  useEffect(() => {
    api.get('/exams')
      .then(res => setExams(res.data))
      .catch(err => console.error('Error fetching exams:', err));
  }, []);

  // Fetch subjects when exam changes
  useEffect(() => {
    if (formData.exam) {
      api.get(`/subjects?exam_id=${formData.exam}`)
        .then(res => setSubjects(res.data))
        .catch(err => console.error('Error fetching subjects:', err));
    } else {
      setSubjects([]);
      setFormData(prev => ({ ...prev, subject: '', topic: '' }));
    }
  }, [formData.exam]);

  // Fetch topics when subject changes
  useEffect(() => {
    if (formData.subject) {
      api.get(`/topics?subject_id=${formData.subject}`)
        .then(res => setTopics(res.data))
        .catch(err => console.error('Error fetching topics:', err));
    } else {
      setTopics([]);
      setFormData(prev => ({ ...prev, topic: '' }));
    }
  }, [formData.subject]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
      ...(name === 'exam' && { subject: '', topic: '' }),
      ...(name === 'subject' && { topic: '' })
    }));
  };

  const handleGenerate = async () => {
    const { exam, subject, topic, validDays, quantity, expiryDate } = formData;

    if (!exam || !validDays || !quantity) {
      setErrorMessage("Please fill all required fields before generating the voucher.");
      setErrorToast(true);
      return;
    }

    setLoading(true);

    try {
      const payload = {
        exam_id: exam,
        valid_days: validDays,
        quantity: quantity,
        expiry_date: expiryDate || null,
      };

      if (subject) payload.subject_id = subject;
      if (topic) payload.topic_id = topic;

      await api.post('/vouchers/generate', payload);

      // Show success toast first
      setSuccessToast(true);

      // Reset form
      setFormData({ exam: "", subject: "", topic: "", validDays: "", quantity: "", expiryDate: "" });

      // Close modal after short delay to let toast display
      setTimeout(() => {
        setSuccessToast(false); // hide toast after auto duration
        onClose();
      }, 1000); // 1 second delay

    } catch (error) {
      console.error("Error generating vouchers:", error);
      setErrorMessage("Something went wrong while generating vouchers. Please try again.");
      setErrorToast(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal
        open={true}
        onClose={onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500, sx: { backdropFilter: 'blur(3px)' } }}
      >
        <Fade in={true}>
          <Box sx={style}>
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                position: "absolute",
                right: 12,
                top: 12,
                color: "#f44336",
                "&:hover": { backgroundColor: "rgba(0,0,0,0.05)", color: "#b71c1c" }
              }}
            >
              <CloseIcon />
            </IconButton>

            <Typography
              variant="h6"
              fontSize={{ xs: '1.3rem', sm: '1.6rem' }}
              mb={2}
              sx={{
                fontWeight: 'bold',
                textAlign: 'center',
                textTransform: 'uppercase',
                background: 'linear-gradient(90deg, #007BFF, #00d4ff)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                letterSpacing: '1px',
              }}
            >
             🏷️ Create Voucher
            </Typography>

            {/* Exam Dropdown */}
            <TextField
              select
              required
              label="Exam"
              name="exam"
              fullWidth
              margin="normal"
              value={formData.exam}
              onChange={handleChange}
            >
              {exams.map(ex => <MenuItem key={ex.id} value={ex.id}>{ex.title}</MenuItem>)}
            </TextField>

            {/* Subject Dropdown */}
            <TextField
              select
              label="Subject"
              name="subject"
              fullWidth
              margin="normal"
              value={formData.subject}
              onChange={handleChange}
            >
              {subjects.map(sub => <MenuItem key={sub.id} value={sub.id}>{sub.name}</MenuItem>)}
            </TextField>

            {/* Topic Dropdown */}
            <TextField
              select
              label="Topic"
              name="topic"
              fullWidth
              margin="normal"
              value={formData.topic}
              onChange={handleChange}
              disabled={!formData.subject}
            >
              {topics.filter(t => t.subject_id === formData.subject).map(topic => (
                <MenuItem key={topic.id} value={topic.id}>{topic.title}</MenuItem>
              ))}
            </TextField>

            {/* Valid Days */}
            <TextField
              name="validDays"
              required
              type="number"
              label="Valid Days"
              fullWidth
              margin="normal"
              value={formData.validDays}
              onChange={handleChange}
            />

            {/* Quantity */}
            <TextField
              name="quantity"
              required
              type="number"
              label="Quantity"
              fullWidth
              margin="normal"
              value={formData.quantity}
              onChange={handleChange}
            />

            {/* Expiry Date */}
            {/* <TextField
              name="expiryDate"
              type="date"
              label="Expiry Date"
              fullWidth
              margin="normal"
              InputLabelProps={{ shrink: true }}
              value={formData.expiryDate}
              onChange={handleChange}
            /> */}

            <Button
              fullWidth
              variant="contained"
              color="primary"
              startIcon={<FiZap />}
              onClick={handleGenerate}
              disabled={loading}
              sx={{
                mt: 2,
                borderRadius: 2,
                fontWeight: 'bold',
                '&:hover': { transform: 'scale(1.05)', boxShadow: '0 0 12px rgba(0, 123, 255, 0.4)' }
              }}
            >
              {loading ? 'Generating...' : 'Generate Voucher'}
            </Button>

            <Button
              fullWidth
              variant="outlined"
              color="secondary"
              onClick={onClose}
              sx={{ mt: 1, borderRadius: 2 }}
            >
              Cancel
            </Button>
          </Box>
        </Fade>
      </Modal>

      {/* Success Toast */}
      <Snackbar
        open={successToast}
        autoHideDuration={3000}
        onClose={() => setSuccessToast(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setSuccessToast(false)} severity="success" sx={{ width: '100%' }}>
          Voucher created successfully!
        </Alert>
      </Snackbar>

      {/* Error Toast */}
      <Snackbar
        open={errorToast}
        autoHideDuration={4000}
        onClose={() => setErrorToast(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setErrorToast(false)} severity="error" sx={{ width: '100%' }}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default VoucherFormModal;



